import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import Button from 'components/Button';
import Form from 'components/Form';
import FormColumn from 'components/FormColumn';
import FormRow from 'components/FormRow';
import LoadingCircle from 'components/LoadingCircle';
import Modal from 'components/Modal';
import Textbox from 'components/Textbox/index';

export default class AlgorithmEditModal extends React.Component {
    static propTypes = {
        algorithm: PropTypes.object.isRequired,
        closeEditModal: PropTypes.func.isRequired,
        dataToEdit: PropTypes.object.isRequired,
        defaultAlgorithm: PropTypes.object.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        isSaving: PropTypes.bool,
        setAlgorithm: PropTypes.func.isRequired,
        show: PropTypes.bool
    };

    _handleChange(event) {
        let newAlgorithmObj = update(this.props.algorithm, {});
        newAlgorithmObj[this.props.dataToEdit.name] = event.target.value ? parseFloat(event.target.value) : '';
        this.props.setAlgorithm(newAlgorithmObj);
    }

    render() {
        let { isSaving } = this.props;
        let { label, name } = this.props.dataToEdit;
        return (
            <Modal className="algorithm-edit-modal"
                   contentLabel="Edit an algorithm field"
                   show={this.props.show === true}
                   title={`Edit "${label}"`}>
                <Form>
                    <FormRow>
                        <Textbox
                            id="txtEditValue"
                            label={label}
                            name={name}
                            onChange={this._handleChange.bind(this)}
                            type="number"
                            value={this.props.algorithm[name]}
                        />
                        <div className="default-value">
                            Default value: <strong>{this.props.defaultAlgorithm[name]}</strong>
                        </div>
                    </FormRow>

                    <FormRow className="button-wrapper" hasColumns>
                        <FormColumn>
                            <Button type="submit"
                                    disabled={isSaving}
                                    onClick={this.props.handleSubmit.bind(this)}>
                                Save
                                {isSaving === true ? <LoadingCircle outerColor="#ffffff" /> : null}
                            </Button>
                        </FormColumn>
                        <FormColumn>
                            <Button cancelStyles
                                    type="button"
                                    onClick={this.props.closeEditModal.bind(this)}>
                                Cancel
                            </Button>
                        </FormColumn>
                    </FormRow>
                </Form>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/AlgorithmPage/AlgorithmEditModal/index.js